<template>
  <div class="node-label">
    <field-topic v-if="topics.length" :color="labelColor" :topics="topics" :truncateLength="truncateLength" :gtmType="gtmType"></field-topic>
    <field-section v-else-if="sections.length" :color="labelColor" :sections="sections" :truncateLength="truncateLength" :gtmType="gtmType"></field-section>
    <slot name="speechBalloonLabel"></slot>
    <span v-if="articleType === 'photo-essay'" :style="{ color: labelColor }" class="icon-wrapper icon-wrapper--photo">
      <svg-icon-photo></svg-icon-photo>
    </span>
    <span v-if="articleType === 'video'" class="icon-wrapper icon-wrapper--video">
      <svg-icon-video></svg-icon-video>
    </span>
  </div>
</template>

<script>
import FieldTopic from 'components/node/fields/Topic.vue'
import FieldSection from 'components/node/fields/Section.vue'
import get from 'lodash/get'
import forEach from 'lodash/forEach'
import map from 'lodash/map'
import { getArticleType, isDesktop } from 'mixins/utilities'
import SvgIconPhoto from 'static/svg/icon_photo.svg'
import SvgIconVideo from 'static/svg/icon_video.svg'
import SectionMixin from 'components/mixins/section'

export default {
  name: 'node-label',
  props: {
    truncateLength: {
      type: Number,
    },
    noColor: {
      type: Boolean,
      default: false,
    },
    gtmType: {
      type: Object,
      default: () => ({}),
    },
    ignoreColorDetect: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [SectionMixin],
  components: {
    FieldTopic,
    FieldSection,
    SvgIconPhoto,
    SvgIconVideo,
  },
  computed: {
    labelColor() {
      if (this.noColor) return ''
      if (this.articleType === 'survival-guide') return '#ffff76'
      if (this.sectionColor === '#FCEB40' && isDesktop() && !this.ignoreColorDetect && this.articleType !== 'photo-essay') return '#C5B900'
      return this.sectionColor
    },
    sections() {
      const sections = []
      forEach(get(this, 'node.sections', []), (sectionLineage) => {
        const sectionList = map(sectionLineage, this.$store.getters.term)
        sections.push(sectionList)
      })
      return sections
    },
    topics() {
      return map(get(this, 'node.topics', []), this.$store.getters.term)
    },
    articleType() {
      return getArticleType(this.node)
    },
  },
}
</script>
<style lang="scss">
.node-label {
  @include respond-to("mobile") {
    font-size: rem-calc(16);
  }
  font-weight: bold;
  vertical-align: middle;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: rem-calc(20);

  .icon-wrapper {
    margin-left: rem-calc(8);
    vertical-align: middle;
    position: relative;
    display: flex;
    svg {
      position: relative;
    }
  }

  .icon-wrapper--video svg {
    top: rem-calc(1);
  }

  .fields {
    @include respond-to("mobile") {
      font-size: rem-calc(14);
    }
    display: flex;
    font-size: rem-calc(16);
  }

  svg {
    fill: currentColor;
    width: rem-calc(15);
    height: rem-calc(14);
  }
}
</style>



// WEBPACK FOOTER //
// components/node/Label.vue